import {Component, OnDestroy, OnInit} from "@angular/core";
import {PageLoadingBarService} from './page-loading-bar.service';
import {Subscription} from "rxjs";

@Component({
    selector: 'db-page-loading-bar',
    templateUrl: './page-loading-bar.component.html',
    styleUrls: ['./page-loading-bar.component.scss'],
    standalone: false
})
export class PageLoadingBarComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[];

  public loading: boolean;

  constructor(
    private _pageLoadingBarService: PageLoadingBarService
  ) {
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.addEventHandlers();
  }

  private addEventHandlers(): void {
    this._subscriptions.push(this._pageLoadingBarService.loading$.subscribe((loading: boolean): void => {
      this.loading = loading;
    }));
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }

}
